//@flow
import * as React from 'react'
import type { MorpheusQualityReview$Props } from './flowTypes'
import ContainerRowExpandPanel from '../../components/common/ContainerRowExpandPanel'
import QualityReviewContainer from '../../components/QualityReview/QualityReviewContainer'

const MorpheusQualityReview=(props:MorpheusQualityReview$Props)=>{
    const morpheus = props.morpheus
    let isVisible = false

    if (morpheus.reviewQuestions && morpheus.reviewQuestions.length > 0){
        isVisible = true
    }
    
    return (
        <ContainerRowExpandPanel visible={isVisible} 
        title={'Final Review Before Submission'} elementId={'morpheusQualityReview'} 
        errors={props.noOfErros}
        >
            <QualityReviewContainer 
                elementId={'morpheusPanelReviewQuestion'} 
                changeFieldValue={props.changeFieldValue} 
                questions={(morpheus.reviewQuestions:any)} 
            />
        </ContainerRowExpandPanel>
    )
}

export default MorpheusQualityReview


// WEBPACK FOOTER //
// ./src/views/ProjectMorpheus/MorpheusQualityReview.js